import { StyleSheet, View } from "react-native";
import type { ColorValue, ViewProps } from "react-native";

export type NoticeBoxFrameProps = ViewProps & {
  backgroundColor: ColorValue;
  borderColor: ColorValue;
};

/** Shared notice geometry; callers supply colours, content and layout adjustments. */
export const NoticeBoxFrame = ({
  backgroundColor,
  borderColor,
  children,
  style,
  ...props
}: NoticeBoxFrameProps) => {
  return (
    <View
      {...props}
      style={StyleSheet.compose(
        [styles.container, { backgroundColor, borderColor }],
        style,
      )}
    >
      {children}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    borderWidth: 1,
    borderRadius: 6,
    paddingVertical: 16,
    paddingHorizontal: 16,
    width: "100%",
  },
});
